import React from "react";
import { AxlMiniGroupAssignments, AxlCheckbox, Colors } from "axl-reactjs-ui";
import AxlDraftShipmentBox from "../../AxlDraftShipmentBox";
import { inject, observer } from "mobx-react";
import { withRouter } from "react-router-dom";
import _ from "lodash";
import ReactList from "react-list";
import { LinearProgress } from "@material-ui/core";

import styles, * as E from "./styles";
import { colors } from "../../../themes/colors";

@inject("jobStore")
@observer
class ListShipmentsByJob extends React.Component {
  constructor(props) {
    super(props);
  }

  selectShipment = (s) => (e) => {
    const { jobStore } = this.props;
    if (
      !jobStore.selectedShipment ||
      jobStore.selectedShipment.id.toString() !== s.id.toString()
    ) {
      jobStore.selectedShipment = s;
      this.props.history.push(`/batch/${this.props.match.params.id}/${s.id}`);
    } else {
      jobStore.selectedShipment = null;
      this.props.history.push(`/batch/${this.props.match.params.id}`);
    }
  };

  changeStatusFilter = (name) => (e) => {
    const { jobStore } = this.props;
    jobStore[name] = !jobStore[name];
  };

  renderItem = (index, key) => {
    const { jobStore, isBlur } = this.props;
    const shipment = jobStore.filteredShipments[index];
    const { selectedShipment } = jobStore;

    return (
      <AxlDraftShipmentBox
        theme={`main`}
        onSelectShipment={this.selectShipment(shipment)}
        key={index}
        shipment={shipment}
        status={shipment.status}
        style={{ opacity: !selectedShipment || selectedShipment.id === shipment.id ? 1.0 : 0.5 }}
        isBlur={isBlur}
      />
    );
  };

  render() {
    const listJobUpload = [{ title: "04/17/2019", color: "#bebfc0" }];

    const { jobStore } = this.props;
    const {
      selectedJob,
      erroredShipments,
      passedShipments,
      okShipment,
      errorShipment,
      selectedJobShipments,
      loadingShipments,
      duplicatedShipments,
      duplicatedShipment,
    } = jobStore;

    if (!selectedJob) return null;

    if (loadingShipments) return <LinearProgress color="primary" />;

    if (!selectedJobShipments) return <div>No shipments found</div>;

    const errored = _.defaultTo(erroredShipments.length, 0);
    const passed = _.defaultTo(passedShipments.length, 0);
    const duplicated = _.defaultTo(duplicatedShipments.length, 0);

    return (
      <E.Contain>
        <E.List>
          {listJobUpload.map((item, index) => (
            <AxlMiniGroupAssignments
              indicator={false}
              key={index}
              length={selectedJobShipments.length}
              color={item.color}
              text={""}
              style={styles.panel}
            >
              {jobStore.isDraftJob(selectedJob.status) && (
                <E.CheckboxContainer>
                  <AxlCheckbox
                    name={`ERRORED`}
                    checked={errorShipment}
                    theme={`secondary`}
                    color={`transparent`}
                    onChange={this.changeStatusFilter("errorShipment")}
                    style={{ borderColor: Colors.dustyRed }}
                    markColor={Colors.dustyRed}
                  >{`ERRORED (${errored})`}</AxlCheckbox>
                  <AxlCheckbox
                    name={`DUPLICATED`}
                    checked={duplicatedShipment}
                    theme={`secondary`}
                    color={`transparent`}
                    style={{backgroundColor: colors.lightOrange}}
                    onChange={this.changeStatusFilter("duplicatedShipment")}
                  >{`DUPLICATED (${duplicated})`}</AxlCheckbox>
                  <AxlCheckbox
                    name={`PASSED`}
                    checked={okShipment}
                    theme={`secondary`}
                    color={`darkPastelGreen`}
                    onChange={this.changeStatusFilter("okShipment")}
                  >{`PASSED (${passed})`}</AxlCheckbox>
                </E.CheckboxContainer>
              )}
              {jobStore.selectedJobShipments && (
                <ReactList
                  itemRenderer={this.renderItem}
                  length={jobStore.filteredShipments.length}
                  type="uniform"
                />
              )}
            </AxlMiniGroupAssignments>
          ))}
        </E.List>
      </E.Contain>
    );
  }
}

export default withRouter(ListShipmentsByJob);
